import { render, staticRenderFns } from "./SetPhoneLine.vue?vue&type=template&id=196a048e"
import script from "./SetPhoneLine.vue?vue&type=script&lang=js"
export * from "./SetPhoneLine.vue?vue&type=script&lang=js"
import style0 from "./SetPhoneLine.vue?vue&type=style&index=0&id=196a048e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports